<template>
  <div class="stuErrorStat">
    <div class="pk-top">
      <p class="title"><span>屏4：班级错题本</span></p>
      <div class="pk-top-right">
        <el-date-picker :picker-options="pickerOptions" v-model="time_select" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" @change='timeChange()'>
        </el-date-picker>
        <p class="small">*数据每十秒钟更新一次</p>
      </div>
    </div>
    <div class="bottomChart" v-show="stuErrorData.length>0">
      <el-table :data="stuErrorData" stripe height="100%">
        <el-table-column width="80" label="序号" type="index" :index="indexMethod" />
        <el-table-column property="dcmc" label="单词" />
        <el-table-column property="cccs" label="出错次数" />
        <el-table-column property="ccrs" label="出错人数" />
        <el-table-column property="yctx" label="易错题型" />
      </el-table>
      <div class="tea-pagination">
        <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pages.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pages.total">
        </el-pagination>
      </div>
    </div>
    <div class="empty" v-show="stuErrorData.length==0">
      <el-empty description="暂无数据" class="" v-show="stuErrorData.length==0"></el-empty>
    </div>
  </div>
</template>
<script>
import { wrongQuestionRankingApi } from '@/api/teacher.js'
export default {
  name: 'stuErrorStat',
  data() {
    return {
      search_data: {
        yhid: this.$store.state.userInfo.yhid,
        zhid: this.$store.state.userInfo.zhid,
        bjid: this.$route.query.bjid,
        bjmc: this.$route.query.bjmc,
      },
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      stuErrorData: [],
      pickerOptions: {
        disabledDate: (time) => {
          return this.dealDisabledDate(time)
        }
      },
      time_select: null,//当前时间
      time_section: [],//可选择时间区间
    }
  },
  created() {
    const time_options = JSON.parse(this.$route.query.time)
    this.time_section = [time_options.yxqq, time_options.yxqz];
    this.time_select = time_options.now_select;
  },
  mounted() {
    this.getWrongWordList()
    this.setTimer()
  },
  distroyed: function () {
    clearInterval(this.setTimer())
  },

  methods: {
    // 日期禁选
    dealDisabledDate(time) {
      let start = new Date(this.$utils.getNowTime(0, 0, -1, this.time_section[0])).getTime();
      let now = new Date(this.$utils.getNowTime(0, 0, 0,)).getTime()
      let end = new Date(this.time_section[1]).getTime();
      if (end > now) {
        end = now
      }
      return time < start || time > end
    },
    timeChange() {
      this.handelSearch()
    },
    // 班级错词本
    getWrongWordList() {
      const data = this.search_data;
      data.currentPage = this.pages.currentPage;
      data.pageSize = this.pages.pageSize;
      data.qryDate = this.time_select;
      wrongQuestionRankingApi(data).then(res => {
        if (res.result) {
          this.pages.total = res.result.total
          this.stuErrorData = res.result.list;
        }
      })
    },
    setTimer: function () {
      this.timer = setInterval(() => {
        this.handelSearch()
      }, 10000)
    },

    // 排名计算
    indexMethod(index) {
      return (this.pages.currentPage - 1) * this.pages.pageSize + index + 1;
    },
    handleCurrentChange(val) {
      this.pages.currentPage = val;
      this.getWrongWordList()
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.handelSearch()
    },
    handelSearch() {
      this.pages.currentPage = 1;
      this.getWrongWordList()
    },
  }
}
</script>
<style lang="scss" scope>
.tea-pagination {
  margin-top: 15px;
}
.stuErrorStat {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  padding-top: 20px;

  .pk-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .pk-top-right {
      display: flex;
      align-items: center;
    }
    .small {
      text-align: right;
      font-size: 12px;
      margin: 20px;
      color: red;
    }
    .title {
      span {
        background: #309bff;
        padding: 5px 20px;
        color: #fff;
        border-radius: 18px;
      }
    }
  }
  .bottomChart {
    height: calc(100% - 140px);
    margin-top: 20px;
    background-color: red;
  }
  ::v-deep  .el-table {
    margin: 0px auto;
    // width:561px;
    .el-table__header {
      .has-gutter {
        th {
          background-color: #eee;
        }
      }
    }
    span {
      color: #fff;
      padding: 5px 8px;
      border-radius: 18px;
    }
    .green {
      background: #3bde79;
    }
    .purple {
      background: #c654ff;
    }
    .orange {
      background: #ffc941;
    }
    .blue {
      background: #3b71de;
    }
  }
  .el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #e1f4ff;
  }
}
.empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
